import SideNavLink from 'components/SideNavLink';
import { NEW_HOSPITALS_PATH, useNewHospitalsCount } from 'services/api/admin/newHospitals';

export default function NewHospitalsNavLink({ title }: { title: string }) {
  const count = useNewHospitalsCount();
  return <SideNavLink to={NEW_HOSPITALS_PATH} title={title} badge={count} />;
}
